module.exports = __webpack_public_path__ + "static/media/benefitsPoints.a8e1670f.png";